import { makeVar } from '@apollo/client';
import { MAX_CACHED_FEED_ITEMS } from '@/apollo-cache-utils/update-feed-cache.ts';

export const newPostsVar = makeVar<string[]>([]);

export const trackNewPostId = (postId: string) => {
  const next = [...newPostsVar(), postId];
  newPostsVar(
    next.length > MAX_CACHED_FEED_ITEMS
      ? next.slice(next.length - MAX_CACHED_FEED_ITEMS)
      : next,
  );
};
